import { render, staticRenderFns } from "./OrganizationTableWS.vue?vue&type=template&id=1c59122a&scoped=true"
import script from "./OrganizationTableWS.vue?vue&type=script&lang=js"
export * from "./OrganizationTableWS.vue?vue&type=script&lang=js"
import style0 from "./OrganizationTableWS.vue?vue&type=style&index=0&id=1c59122a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c59122a",
  null
  
)

export default component.exports